import {
  all,
  call,
  debounce,
  put,
  select,
  takeEvery,
} from "redux-saga/effects";
import { PatientsService } from "../../services/PatientsService";
import { patientActions } from "./actions";
import { selectPatientsUI } from "./selectors";
import { selectAuthUser } from "../auth/selectors";

function* getPatients({ payload }) {
  try {
    const patientsList = yield call(PatientsService.getPatientsList, payload);
    if (patientsList.data) {
      const {
        data,
        meta: { pagination },
      } = patientsList.data;

      yield put(patientActions.getPatientsSuccess({ data, pagination }));
    }
  } catch (error) {
    yield put(patientActions.getPatientsError(error));
  }
}

function* patientSave({ payload }) {
  const { data, id } = payload;

  let response;
  if (id) {
    response = yield call(PatientsService.updatePatient, id, data);
  } else {
    response = yield call(PatientsService.savePatient, data);
  }

  if (!response?.data) {
    return;
  }

  yield put(patientActions.hideAddPatientModal());

  if (id) {
    yield put(patientActions.currentPatientRefresh({}));
  }

  const { perPage, page } = yield select(selectPatientsUI);

  yield put(
    patientActions.getPatients({
      per_page: perPage,
      page,
      order: "desc",
    })
  );
}

function* patientDelete({ payload }) {
  const { id } = payload;

  const response = yield call(PatientsService.deletePatient, id);

  if (!response) {
    return;
  }

  const { perPage, page } = yield select(selectPatientsUI);
  yield put(
    patientActions.getPatients({
      per_page: perPage,
      page,
      order: "desc",
    })
  );
}

function* getSearchPatients({ payload }) {
  const { search } = payload;

  const { lab } = yield select(selectAuthUser);

  try {
    const response = yield call(PatientsService.getPatientsList, {
      labId: lab.id,
      page: 1,
      per_page: 10,
      params: { query: search, sort_by: "ssn,first_name,last_name" },
    });

    if (!response) {
      yield put(patientActions.getSearchPatientsError());
      return;
    }

    const parsedSearchPatients =
      response.data.data.map((p) => ({
        id: p.id,
        label: `${p.attributes.first_name} ${p.attributes.last_name}, ${p.attributes.ssn}`,
      })) || [];

    yield put(patientActions.getSearchPatientsSuccess(parsedSearchPatients));
  } catch (error) {
    yield put(patientActions.getSearchPatientsError());
  }
}

export default function* patientsSaga() {
  yield all([
    takeEvery(patientActions.GET_PATIENTS, getPatients),
    takeEvery(patientActions.PATIENT_SAVE, patientSave),
    takeEvery(patientActions.PATIENT_DELETE, patientDelete),
    debounce(300, patientActions.GET_SEARCH_PATIENTS, getSearchPatients),
  ]);
}
